<template>
    <v-container grid-list text-center>
        <v-progress-circular v-if="loading" size="140" width="12" color="primary" indeterminate />

        <v-flex xs12 v-else>
            <v-card dark color="primary" v-if="stores == null || stores.length == 0">
                <div class="d-flex flex-no-wrap justify-space-between">
                    <v-card-title>{{ labelNotFound }}</v-card-title>
                </div>
            </v-card>
            <v-layout wrap v-else>
                <v-flex xs12 class="ma-0 pa-0">
                    <p class="font-weight-black">{{ labelSelect }}</p>
                </v-flex>
                <v-flex xs12 class="my-0 py-0">
                    <v-text-field :label="$t('Filtrar...')" v-model="filterName" clearable hide-details/>
                </v-flex>
                <v-flex xs12 v-for="item of listWithFilter" :key="item.id" class="ma-2">
                    <v-btn color="success" class="mx-auto" width="100%" @click="$emit('selected', item)">
                        {{ item.name }}
                    </v-btn>
                </v-flex>
                <v-flex xs12 v-if="mainList.length > 0 && showMore == false" class="ma-2">
                    <v-btn color="error" class="mx-auto" width="100%" @click="showMore = true">
                        Coleta Shopping
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-container>
</template>

<script>

export default {
    name: "StoreList",

    props: {
        endpoint: {
            type: String,
            required: true,
        },
        labelNotFound: {
            type: String,
            default: "Não foi localizado nenhuma loja.",
        },
        labelSelect: {
            type: String,
            default: "Selecione abaixo a loja:",
        },
        mainList: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            loading: true,
            filterName: null,
            stores: [],
            showMore: false,
        };
    },

    mounted() {
        this.getStores();
    },

    computed: {
        listWithFilter() {
            let ret = this.stores;
            if (this.filterName) {
                let exp = new RegExp(this.filterName.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, ""), "i");
                ret = ret.filter(
                    (item) => typeof item === "object" && item !== null && exp.test(JSON.stringify(Object.values(item)).normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
                );
            }
            if (this.mainList.length > 0) {
                if (this.showMore == true) {
                    return ret.filter(item => this.mainList.some(v => item.name.includes(v)) == false);
                } else {
                    return ret.filter(item => this.mainList.some(v => item.name.includes(v)) == true);
                }
            }

            return ret;
        },
    },

    methods: {
        getStores() {
            this.$http
                .get(this.endpoint)
                .then((result) => {
                    if (result) {
                        this.stores = result;
                    }
                })
                .catch(() => {
                    this.stores = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>